import { PlanId } from 'domains/models/subscription/planId';
import SubscriptionFeature from 'domains/models/subscription/features';

export default class RoutingFormFeature extends SubscriptionFeature {
  static unlimitedCount = 999999;
  static currentPlanId = PlanId.Free;
  validPlanId() {
    return RoutingFormFeature.currentPlanId;
  }

  isValid(planId: PlanId) {
    return planId >= this.validPlanId();
  }

  canAdd(planId: PlanId, routingFormCount: number) {
    return this.maxCount(planId) > routingFormCount;
  }

  maxCount(planId: PlanId) {
    switch (planId) {
      case PlanId.Free:
      case PlanId.Pro:
      case PlanId.Team:
      case PlanId.Enterprice:
        return RoutingFormFeature.unlimitedCount;
      default:
        return 1;
    }
  }
}
